import { action, Action, thunk, Thunk } from 'easy-peasy'
import { RegionalConfig} from '../../Types'

export interface State {
  hasOutage: boolean
}
// eslint-disable-next-line
export interface Actions {
  setHasOutage: Action<this, number>
   // eslint-disable-next-line
  clearHasOutage: Action<this>
}
// eslint-disable-next-line
export interface Thunks {
  checkRegionUpdate: Thunk<this, { config?: RegionalConfig, hasHttpError?: boolean }>
}

export interface RegionModel extends State, Actions, Thunks {}

const hasActiveOutageTimeout = (): boolean => {
  const outageTimeout = Number(localStorage.getItem('OutageTimeout'));
  return new Date().getTime() < (outageTimeout ?? 0);
}

export const regionModel: RegionModel = {
  hasOutage: hasActiveOutageTimeout(),

  // action
  setHasOutage: action((state, timeoutMinutes) => {
    state.hasOutage = true
    // set outage timeout for next x minutes
    localStorage.setItem('OutageTimeout', `${new Date().getTime() + 60000 * timeoutMinutes}`)
  }),
  clearHasOutage: action(state => {
    if (!hasActiveOutageTimeout()) {
      state.hasOutage = false
      // set outage timeout for next x minutes
      localStorage.removeItem('OutageTimeout')
    }
  }),

  // thunk
  checkRegionUpdate: thunk(async (actions, payload) => {
    if (payload.hasHttpError === true) {
      actions.setHasOutage(2)
    } else {
      actions.clearHasOutage()
    }
  })
}
